<template>
    <transition mode="out-in" name="fade">
    <div class="container-fluid touch-page" v-if="show">
        <div class="inline100">
            <h1>Leagues: {{name}}</h1>
            <table class="leagues_by_days">
                <tr>
                    <td v-for="d in maxDays">{{dayOfWeek[d]}}</td>
                </tr>
                <tr v-for="s in maxSession">
                    <td v-for="d in maxDays">
                        <div class="element clearfix" v-for="el in matrix[s][d]">
                            <div class="time pull-left">
                                {{el.time}}
                            </div>
                            <router-link class="btn btn-league" active-class="active" :to="'/leagues/view/'+el.id">{{el.name}}</router-link>
                        </div>
                </td>
                </tr>
            </table>
        </div>
        <div class="buttons center">
            <router-link class="btn btn-big btn-back" active-class="active" to="/">Home Page</router-link>
        </div>
    </div>
        <div v-else>
            <div class="loader" id="loader-1"></div>
        </div>
    </transition>
</template>
<script>
    import axios from 'axios'
    export default{
        data(){
            return{
                name: null,
                matrix: null,
                maxDays:null,
                maxSession:null,
                dayOfWeek:['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday','Sunday'],
                show: false
            }
        },
        mounted (){
            axios.get('/ajax.php?q=getLeagueList')
            .then(res => {
               console.log(res);
               this.name = res.data.element.name;
               this.matrix = res.data.element.items;
               this.maxDays = res.data.element.maxDay;
               this.maxSession = res.data.element.maxSession;
               this.show = true;
            })
            .catch(error => console.log(error))
        }
    }
</script>
<style scoped>
.btn-big.btn-back{
    background: #337ab7;
}
</style>


// WEBPACK FOOTER //
// src/components/Leagues/List.vue